import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

export function SuiteConfirm({ open, title, body, confirmLabel, onCancel, onConfirm, testid }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="suite-root rounded-2xl bg-[#0B0F17] border border-purple-500/40 text-slate-200" data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white font-display text-2xl">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-300">{body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-white/20 text-slate-200 hover:bg-white/10 hover:text-white" data-testid={`${testid}-keep`}>Keep plan</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-rose-500 hover:bg-rose-400 text-white" data-testid={`${testid}-confirm`}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

// "This batch will use X credits. You will have Y remaining. Proceed?"
export function BatchConfirm({ open, count, plan, ai, images, onCancel, onConfirm }) {
  const available = plan?.available ?? 0;
  const remaining = available - count;
  const short = remaining < 0;
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="suite-root rounded-2xl bg-[#0B0F17] border border-purple-500/40 text-slate-200 shadow-[0_0_40px_rgba(147,51,234,0.3)]" data-testid="batch-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white font-display text-2xl">{short ? "Not enough credits" : "Confirm batch"}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-300 text-base" data-testid="batch-confirm-text">
            {short
              ? `This batch needs ${count} credits but you have ${available}. Remove some files or buy 100 add-on credits for $5.`
              : `This batch will use ${count} credits. You will have ${remaining} remaining. Proceed?`}
            {ai && <span className="block mt-2 text-sm text-purple-300" data-testid="batch-confirm-ai-note">{images} images × 2 credits (1 processing + 1 AI description).</span>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-white/20 text-slate-200 hover:bg-white/10 hover:text-white" data-testid="batch-confirm-cancel">Cancel</AlertDialogCancel>
          {!short && (
            <AlertDialogAction onClick={onConfirm} className="bg-gradient-to-r from-cyan-500 via-purple-600 to-emerald-500 text-white" data-testid="batch-confirm-proceed">
              Proceed
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
